/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CashflowForecastSettings', 'model/CashflowForecastDataReport', 'model/CashflowForecastSettingsReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CashflowForecastSettings'), require('../model/CashflowForecastDataReport'), require('../model/CashflowForecastSettingsReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CashflowForecastSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CashflowForecastSettings, root.ForStractionServiceApi.CashflowForecastDataReport, root.ForStractionServiceApi.CashflowForecastSettingsReport);
  }
}(this, function(ApiClient, CashflowForecastSettings, CashflowForecastDataReport, CashflowForecastSettingsReport) {
  'use strict';

  /**
   * CashflowForecastSettings service.
   * @module api/CashflowForecastSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new CashflowForecastSettingsApi. 
   * @alias module:api/CashflowForecastSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the cashflowForecastSettingsEditPut operation.
     * @callback module:api/CashflowForecastSettingsApi~cashflowForecastSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/CashflowForecastSettings} body 
     * @param {module:api/CashflowForecastSettingsApi~cashflowForecastSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastSettingsEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastSettingsLoadDataReportGet operation.
     * @callback module:api/CashflowForecastSettingsApi~cashflowForecastSettingsLoadDataReportGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CashflowForecastDataReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadDataReport
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxReceivablesCount  (default to 0)
     * @param {Integer} opts.maxEventsCount  (default to 0)
     * @param {module:api/CashflowForecastSettingsApi~cashflowForecastSettingsLoadDataReportGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CashflowForecastDataReport}
     */
    this.cashflowForecastSettingsLoadDataReportGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastSettingsLoadDataReportGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxReceivablesCount': opts['maxReceivablesCount'],
        'maxEventsCount': opts['maxEventsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = CashflowForecastDataReport;

      return this.apiClient.callApi(
        '/CashflowForecastSettings/loadDataReport', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastSettingsLoadGet operation.
     * @callback module:api/CashflowForecastSettingsApi~cashflowForecastSettingsLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CashflowForecastSettingsReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {module:api/CashflowForecastSettingsApi~cashflowForecastSettingsLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CashflowForecastSettingsReport}
     */
    this.cashflowForecastSettingsLoadGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastSettingsLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = CashflowForecastSettingsReport;

      return this.apiClient.callApi(
        '/CashflowForecastSettings/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastSettingsRecalculateGet operation.
     * @callback module:api/CashflowForecastSettingsApi~cashflowForecastSettingsRecalculateGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * recalculate
     * @param {String} _4SAPIAppID 
     * @param {module:api/CashflowForecastSettingsApi~cashflowForecastSettingsRecalculateGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastSettingsRecalculateGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastSettingsRecalculateGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastSettings/recalculate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
